
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://regbqpvypwfbcfmoqsab.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJlZ2JxcHZ5cHdmYmNmbW9xc2FiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDM0ODM3ODIsImV4cCI6MjA1OTA1OTc4Mn0.2s2_CJx3CnTvC0ZkggzreYgxpFY35_WlGy3uvDLo4Ds";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'implicit',
  }
});

// Debug auth state
supabase.auth.onAuthStateChange((event, session) => {
  console.log(`Supabase auth event: ${event}`, { 
    hasSession: !!session, 
    user: session?.user?.email,
    metadata: session?.user?.user_metadata 
  });
});
